import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from './store'; 
import { checkMembership } from './store/slices/authSlice';
import useToggleStyle from 'hooks/useToggleStyle';
import { useAppContext } from 'providers/AppProvider';
import { useSettingsPanelContext } from 'providers/SettingsPanelProvider';

const App: React.FC = () => {
  const { isStylesheetLoaded } = useToggleStyle();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  // Selectors
  const token = useSelector((state: RootState) => state.auth.token);
  const status = useSelector((state: RootState) => state.auth.status);

  // 1. Auth Guard & Redirection Logic
  useEffect(() => {
    const publicRoutes = ['/login', '/register', '/forgot-password'];
    const isPublicRoute = publicRoutes.includes(pathname);

    // If no token and trying to access a protected route, redirect to login
    if (!token && !isPublicRoute) {
      navigate('/login');
    }
  }, [token, pathname, navigate]);

  // 2. Membership Check
  useEffect(() => {
    if (token) {
      dispatch(checkMembership());
    }
  }, [token, dispatch]);

  const {
    settingsPanelConfig: { showSettingPanelButton },
    setSettingsPanelConfig
  } = useSettingsPanelContext();

  const {
    config: { theme, isRTL }
  } = useAppContext();

  // 3. Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // 4. Settings Panel Reset
  useEffect(() => {
    setSettingsPanelConfig({
      openSettingPanel: false
    });
  }, [isRTL, setSettingsPanelConfig]);

  return (
    <>
      {!isStylesheetLoaded ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: theme === 'dark' ? '#000' : '#fff'
          }}
        />
      ) : (
        <>
          <Outlet />
          {showSettingPanelButton && (
            <>
              {/* Your settings panel button code here */}
            </>
          )}
        </>
      )}
    </>
  );
};

export default App;